// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"32":"bbddcd51d4efc7a9","463":"5acff61eeb293d07","640":"615e8e2d2c748963","869":"95a411ab678f910d"}[chunkId] + ".js";
};